import React from 'react';
import { useCart } from './CartContext';
import './CartPage.css';
import { CONTACT_PHONE, CONTACT_PHONE_LABEL, CONTACT_EMAIL, CONTACT_MAX } from './contacts';

const CartPage = () => {
  const { cart, removeFromCart, updateQuantity } = useCart();
  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const formatPrice = (price) => {
    return new Intl.NumberFormat('ru-RU', {
      maximumFractionDigits: 0,
    }).format(Number(price));
  };

  return (
    <div className="cart-container">
      <h2>Корзина</h2>
      {cart.length === 0 ? (
        <p className="empty-cart">Корзина пуста</p>
      ) : (
        <>
          <ul className="cart-list">
          {cart.map(item => (
            <li key={item.id} className="cart-item">
              <div style={{ flexGrow: 1 }}>
                <strong>{item.name}</strong><br />
                Цена: {formatPrice(item.price)} ₽ ×
                <input
                  type="number"
                  min="1"
                  max={item.stock || 9999}
                  value={item.quantity === 0 ? '' : item.quantity}
                  onChange={(e) => {
                    const raw = e.target.value;

                    // Разрешаем стирание (временно)
                    if (raw === '') {
                      updateQuantity(item.id, 0); // Временно 0, чтобы показать пустую строку
                      return;
                    }

                    const parsed = parseInt(raw, 10);
                    if (!isNaN(parsed)) {
                      const clamped = Math.max(1, Math.min(parsed, item.stock || 9999));
                      updateQuantity(item.id, clamped);
                    }
                  }}
                  style={{ width: '60px', marginLeft: '0.5rem', marginRight: '0.5rem' }}
                />



                = <strong>{formatPrice(item.quantity * item.price)} ₽</strong>
              </div>
              <button className="remove-btn" onClick={() => removeFromCart(item.id)}>Удалить</button>
            </li>
          ))}

          </ul>
          <h3 className="total-price">Итого: {formatPrice(total)} ₽</h3>

          <div className="contact-us-block">
            <h3>Связаться с нами</h3>
            <p>Чтобы оформить заказ по товарам из корзины, свяжитесь с нами любым удобным способом:</p>
            <ul className="contact-us-list">
              <li><a href={`tel:${CONTACT_PHONE}`}>{CONTACT_PHONE_LABEL}</a></li>
              <li><a href={`mailto:${CONTACT_EMAIL}`}>✉ {CONTACT_EMAIL}</a></li>
              <li>Max: {CONTACT_MAX}</li>
            </ul>
          </div>
        </>
      )}
    </div>
  );
};

export default CartPage;
